import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: `url('/images/about-hero.jpg')` }}
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About ZOLO</h1>
            <p className="text-xl mb-8">
              Your trusted business growth partner in Chhindwara and beyond
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-8">
            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-zolo-blue pb-3">Our Story</h2>
              <p className="text-lg text-gray-700 mb-6">
                Founded in 2018 in the heart of Chhindwara, ZOLO Service began with a simple mission: to help local businesses thrive in the digital age. What started as a small team of passionate digital marketers has grown into a comprehensive business growth agency serving clients across India.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Our journey has been defined by continuous learning, adaptation, and a relentless focus on delivering measurable results for our clients. We understand the unique challenges faced by businesses in tier-2 and tier-3 cities, and we've tailored our services to address these specific needs while maintaining world-class standards.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Today, ZOLO Service stands as a trusted partner for businesses of all sizes, from local startups to established enterprises, helping them navigate the complex digital landscape and achieve sustainable growth.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-zolo-blue pb-3">Our Vision</h2>
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-8 rounded-lg text-white mb-8">
                <p className="text-xl italic font-medium">
                  "To empower businesses across India with accessible, effective digital solutions that drive meaningful growth and success in an increasingly connected world."
                </p>
              </div>
              <p className="text-lg text-gray-700 mb-6">
                At ZOLO Service, we envision a future where every business, regardless of size or location, has access to the digital tools and expertise needed to thrive in the modern marketplace. We believe in breaking down the barriers to digital adoption and creating pathways to success for businesses at every stage of their journey.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-zolo-blue pb-3">Our Mission</h2>
              <p className="text-lg text-gray-700 mb-6">
                Our mission is to deliver tailored, results-driven digital solutions that help businesses connect with their audiences, build their brands, and achieve sustainable growth. We are committed to:
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2 text-gray-800">Excellence</h4>
                  <p className="text-gray-700">
                    Maintaining the highest standards in every aspect of our work, from strategy development to execution and reporting.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2 text-gray-800">Innovation</h4>
                  <p className="text-gray-700">
                    Continuously exploring new technologies and approaches to keep our clients at the forefront of digital trends.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2 text-gray-800">Transparency</h4>
                  <p className="text-gray-700">
                    Building trust through clear communication, honest reporting, and accountable business practices.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2 text-gray-800">Partnership</h4>
                  <p className="text-gray-700">
                    Working as an extension of our clients' teams, deeply understanding their businesses and aligning with their goals.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-zolo-blue pb-3">Our Values</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Integrity</h4>
                  <p className="text-gray-700">
                    We do what's right, not what's easy, and always act in our clients' best interests.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Impact</h4>
                  <p className="text-gray-700">
                    We measure our success by the tangible results we deliver for our clients.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Adaptability</h4>
                  <p className="text-gray-700">
                    We embrace change and continuously evolve our approaches to stay ahead.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Collaboration</h4>
                  <p className="text-gray-700">
                    We believe in the power of teamwork and partnership to achieve extraordinary results.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Innovation</h4>
                  <p className="text-gray-700">
                    We constantly seek new and better ways to solve problems and create opportunities.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2 text-gray-800">Commitment</h4>
                  <p className="text-gray-700">
                    We are dedicated to our clients' success and go above and beyond to deliver on our promises.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-zolo-blue pb-3">Our Goals</h2>
              
              <div className="space-y-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h4 className="font-bold text-xl mb-2 text-gray-800 flex items-center">
                    <span className="bg-zolo-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">1</span>
                    Empower Local Businesses
                  </h4>
                  <p className="text-gray-700 ml-11">
                    Help 1,000+ businesses in tier-2 and tier-3 cities establish a strong digital presence by 2026.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h4 className="font-bold text-xl mb-2 text-gray-800 flex items-center">
                    <span className="bg-zolo-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">2</span>
                    Drive Measurable Growth
                  </h4>
                  <p className="text-gray-700 ml-11">
                    Generate over ₹100 crore in combined revenue for our clients through our digital marketing strategies.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h4 className="font-bold text-xl mb-2 text-gray-800 flex items-center">
                    <span className="bg-zolo-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">3</span>
                    Expand Service Reach
                  </h4>
                  <p className="text-gray-700 ml-11">
                    Establish ZOLO Service as a leading digital agency across Central India with offices in 5 major cities.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h4 className="font-bold text-xl mb-2 text-gray-800 flex items-center">
                    <span className="bg-zolo-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">4</span>
                    Innovate Continuously
                  </h4>
                  <p className="text-gray-700 ml-11">
                    Develop proprietary digital marketing tools and methodologies specifically designed for the Indian market.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h4 className="font-bold text-xl mb-2 text-gray-800 flex items-center">
                    <span className="bg-zolo-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">5</span>
                    Foster Digital Education
                  </h4>
                  <p className="text-gray-700 ml-11">
                    Train and educate 5,000+ business owners and professionals on digital marketing best practices through workshops and webinars.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-4">
            <div className="sticky top-24 space-y-8">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">Why Choose ZOLO?</h3>
                </div>
                
                <div className="p-6">
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span><strong>Local Expertise:</strong> Deep understanding of regional markets and consumer behavior.</span>
                    </li>
                    <li className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span><strong>Comprehensive Solutions:</strong> All digital services under one roof.</span>
                    </li>
                    <li className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span><strong>Results-Driven:</strong> Focus on measurable outcomes and ROI.</span>
                    </li>
                    <li className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span><strong>Personalized Approach:</strong> Tailored strategies for each business.</span>
                    </li>
                    <li className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span><strong>Transparent Communication:</strong> Clear reporting and honest feedback.</span>
                    </li>
                  </ul>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">Our Expertise</h3>
                </div>
                
                <div className="p-6">
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-bold text-lg mb-1">Web Development</h4>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-zolo-blue h-2.5 rounded-full" style={{ width: '95%' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-bold text-lg mb-1">Social Media Marketing</h4>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-zolo-blue h-2.5 rounded-full" style={{ width: '90%' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-bold text-lg mb-1">SEO Services</h4>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-zolo-blue h-2.5 rounded-full" style={{ width: '85%' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-bold text-lg mb-1">Graphic Designing</h4>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-zolo-blue h-2.5 rounded-full" style={{ width: '92%' }}></div>
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="font-bold text-lg mb-1">Google My Business</h4>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div className="bg-zolo-blue h-2.5 rounded-full" style={{ width: '88%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">Get in Touch</h3>
                </div>
                
                <div className="p-6">
                  <p className="mb-4">Ready to grow your business with ZOLO? Contact us today for a free consultation.</p>
                  <Link 
                    to="/contact" 
                    className="block w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300 text-center"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
